import { render, staticRenderFns } from "./listpenebangan.vue?vue&type=template&id=bb88125a&"
import script from "./listpenebangan.vue?vue&type=script&lang=js&"
export * from "./listpenebangan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports